import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { collection, deleteDoc, doc, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../../services/firebase.config";
import { toast } from "react-toastify";

type IDialogDelete = {
    isOpen: boolean,
    onClose: () => void | null,
    reloadDatas: () => Promise<void> | null,
    allItems: boolean,
    item?: any
    typeObject: string
}

const DialogDelete = ({ isOpen, onClose, reloadDatas, allItems, item, typeObject }: IDialogDelete) => {

    const deleteAll = async () => {
        try {
            const itemsRef = collection(db, typeObject);
            const queryItems = query(itemsRef);
            const querySnapshot = await getDocs(queryItems);
            if (querySnapshot.empty) {
                return toast.error("Il n'y a aucune donnée en base de données", { position: "bottom-center", theme: "colored" });
            }
            querySnapshot.forEach(async (item) => {
                await deleteDoc(doc(db, typeObject, item.id));
            });
            toast.success("Les données on bien été supprimées", { position: "bottom-center", theme: "colored" });

            reloadDatas();
            onClose();
        } catch (error) {
            toast.error("Une erreur est survenue lors de la suppression des données. Veuillez contacter l'administrateur.", { position: "bottom-center", theme: "colored" });
        }
    };

    const deleteItem = async () => {
        if (item === null) return toast.error("Une erreur est survenue", { position: "bottom-center", theme: "colored" });
        try {
            // On vérifie que la donnée existe bien en base de données
            const itemsRef = collection(db, typeObject);
            if (typeObject === 'vaches') {
                const queryItem = query(itemsRef, where("Num_catalogue", "==", item.Num_catalogue));
                const querySnapshot = await getDocs(queryItem);

                if (querySnapshot.empty) {
                    return toast.error("Cette Vache n'existe pas en base de données", { position: "bottom-center", theme: "colored" });
                } else {
                    // On supprime la vache si elle existe
                    await deleteDoc(doc(db, "vaches", querySnapshot.docs[0].id));
                    toast.success("La vache a bien été supprimée", { position: "bottom-center", theme: "colored" });
                }
            } else {
                const data = await getDocs(itemsRef);
                const eventExistInBDD = data.docs.map((doc) => doc.id).includes(item.id);
                if (!eventExistInBDD) {
                    return toast.error("Cet évènement n'existe pas en base de données", { position: "bottom-center", theme: "colored" });
                } else {
                    // On supprime l'évènement si elle existe
                    await deleteDoc(doc(db, "events", item.id));
                    toast.success("L'évènement a bien été supprimée", { position: "bottom-center", theme: "colored" });
                }
            }

            reloadDatas();
            onClose();
        } catch (error) {
            toast.error("Une erreur est survenue lors de la suppression de la donnée. Veuillez contacter l'administrateur.", { position: "bottom-center", theme: "colored" });
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={() => onClose()}
        >
            <DialogTitle>
                {typeObject === 'vaches' ?
                    (allItems ? "Êtes-vous sûr de vouloir supprimer toutes les vaches ?" : "Êtes-vous sûr de vouloir supprimer la vache ?") :
                    (allItems ? "Êtes-vous sûr de vouloir supprimer tous les évènements ?" : "Êtes-vous sûr de vouloir supprimer l'évènement ?")}
            </DialogTitle>
            {!allItems ? (
                <DialogContent>
                    {typeObject === 'vaches' ? item?.Num_catalogue : item?.Title} - {typeObject === 'vaches' ? item?.Nom_long : item?.StartDate?.toString()}
                </DialogContent>
            ) : null}
            <DialogActions>
                <Button variant="contained" aria-label="Annuler l'action" color="error" onClick={() => onClose()}>Annuler</Button>
                <Button variant="contained" aria-label="Confirmer l'action" color="success" onClick={() => allItems ? deleteAll() : deleteItem()}>Confirmer</Button>
            </DialogActions>
        </Dialog>
    );
}
export default DialogDelete;